import { IListIndicatorBionexo } from "models/ListIndicatorBionexo";
import { IRequestConfig } from "models/Axios";
import { PortalOrder } from "models/portalModels/PortalOrder";
import { formatISO } from "date-fns";
import axios from "axios";
import Services from "./index.service";
import qs from "qs";

export default class PreOrderIndicatorServices extends Services<
  PortalOrder[],
  PortalOrder
> {

  public GetTotalPreOrders = async (
    businessUnitIdentifier?: string[],
    sellerCodes?: string[],
    status?: number[],
    startDate?: Date | undefined,
    endDate?: Date | undefined,
    origin?: string[]
  ) =>
    await this.FindIndicator(
      "total",
      businessUnitIdentifier,
      sellerCodes,
      status,
      startDate,
      endDate,
      origin
    );

  private FindIndicator = async (
    endpoint: string,
    businessUnitIdentifier?: string[],
    sellerCodes?: string[],
    status?: number[],
    startDate?: Date | undefined,
    endDate?: Date | undefined,
    origin?: string[]
  ) => {
    const config: IRequestConfig<IListIndicatorBionexo> = {
      url: `${this.mafraq_url2}/preOrder/indicador/${endpoint}`,
      params: {
        BusinessUnitIdentifier: businessUnitIdentifier,
        SellerCodes: sellerCodes,
        Status: status,
        StartDate: startDate ? formatISO(startDate) : null,
        EndDate: endDate ? formatISO(endDate) : null,
        Origin: origin
      },
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "repeat", skipNulls: true }),
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
    };

    return new Promise<number>(async (resolve, reject) => {
      axios(config)
        .then((response) => { resolve(response.data); })
        .catch((error)=> { reject(error); })
    });
  };
}
